// 互換レイヤ：以前の import パスに対応するための再エクスポート
export { fetchCurrentUser } from './authkit/server';              // SSR用
export { normalizeUser, isStaff, type AuthUser } from './authkit/shared';
export { csrfFetch, fetchCurrentUserClient } from './authkit/client'; // CSR用
